import React, { useEffect } from "react";
import { Alert, Button } from "@mantine/core";
import QueueApi from "../../data/api/queueApi";
import { CenteredLoader } from "../common/loader";

export const QueueManager: React.FC<{}> = () => {

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<string | null>(null);
    const [status, setStatus] = React.useState<string>();

    function getStatus() {
        return QueueApi.getStatus()
            .then(_status => {
                setStatus(_status)
                setIsLoading(false)
            })
            .catch(er => {
                setIsLoading(false)
                setError(er.message)
            })
    }

    function purgeQueue() {
        return QueueApi.purge()
            .then(_status => {
                setStatus(_status)
                setIsLoading(false)
            })
            .catch(er => {
                setIsLoading(false)
                setError(er.message)
            })

    }

    useEffect(() => {
        document.title = "Queue Manager"
        getStatus()
            .then(console.log)

    }, [])

    return <div>
        <h1>Queue Manager</h1>
        {error && <Alert color="red">{error}</Alert>}

        {<Alert color="blue">
            {isLoading && <CenteredLoader />}
            {status}
            <br />
            <Button color="error" onClick={purgeQueue}>Purge Queue</Button>
            <Button variant="outline" onClick={getStatus}>Refresh</Button>
        </Alert>}
    </div >
}
